import Component from "@glimmer/component"
import styles from "./top-part.module.css"

export default class PlannerCardStacksCardsPartsTopPartComponent extends Component {
  readonly styles = styles
}
